// Environment configuration
const isDevelopment = import.meta.env.DEV || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const config = {
  // API Base URL
  apiBaseUrl: isDevelopment 
    ? 'http://localhost/kuwait/backend'
    : '/backend',
    
  // Assets Base URL  
  assetsBaseUrl: isDevelopment
    ? 'http://localhost/kuwait'
    : '',
    
  // Products images path
  productsImagePath: isDevelopment
    ? 'http://localhost/kuwait/products'
    : '/products',
    
  // Placeholder image
  placeholderImage: '/products/placeholder.jpg'
};

export default config;